import * as React from 'react';

import { IconButton } from '~shared/components/buttons';
import { IconArrow } from '~shared/components/icons/large';

import { useModalMenu } from './';

export function ModalMenuBackButton() {
  const [, setShowSidebar] = useModalMenu();

  return (
    <IconButton appearance="ghost" onClick={() => setShowSidebar(true)}>
      <IconArrow direction="left" />
    </IconButton>
  );
}
